@if (!(isPhonePortrait$ | async)) {
  <div class="computer">
    <div class="photo">
      <img
      [src]="
        productInPackage.productInPackageId
          | productInPackagePhoto: packageId
          | async
          | publicImageUrl: 400:400
          | async
      "
        />
      </div>
      <div class="information">
        <div class="border"></div>
        <ng-container *ngTemplateOutlet="information"></ng-container>
        <div class="buttons">
          <lib-button (click)="hideDialog.emit()" lg forceContext="common" translate>comeBack</lib-button>
        </div>
      </div>
    </div>
  }
  @if (isPhonePortrait$ | async) {
    <div class="phone">
      <img
    [src]="
      productInPackage.productInPackageId
        | productInPackagePhoto: packageId
        | async
        | publicImageUrl: 400:400
        | async
    "
        class="photo"
        />
        <div class="information">
          <ng-container *ngTemplateOutlet="information"></ng-container>
        </div>
        <div class="buttons">
          <lib-button (click)="hideDialog.emit()" forceContext="common" translate>comeBack</lib-button>
        </div>
      </div>
    }

    <ng-template #information>
      <div class="allList">
        <h1>
          @if ((productInPackage.customName | langPicker | async)?.length) {
            <span>
              {{ productInPackage.customName | langPicker | async }}
            </span>
          }
          @if (!(productInPackage.customName | langPicker | async)?.length) {
            <span>
              {{ productInShop.name }}
            </span>
          }
        </h1>
        @for (item of filtered; track item) {
          <ng-container [formGroup]="model">
            <div class="list">
              @switch (item.type) {
                @case ('list') {
                  <div
                    [zalamoTooltip]="item.description | langPicker | async"
                    >
                    {{ item.label | langPicker | async }}:
                    {{ item | oneTextFromList: model.value }}
                  </div>
                }
                @case ('decoration') {
                  <div
                    [zalamoTooltip]="item.description | langPicker | async"
                    >
                    {{ item.label | langPicker | async }}:
                    {{ item | oneTextFromList: model.value }}
                  </div>
                }
                @case ('size') {
                  <div
                    [zalamoTooltip]="item.description | langPicker | async"
                    >
                    {{ item.label | langPicker | async }}:
                    {{ item | oneTextFromList: model.value }}
                  </div>
                }
                @case ('boolean') {
                  <div>
                    <div class="check">
                      @if (item | checkedOrUnchecked: model.value) {
                        <mat-icon
                          >check_circle
                        </mat-icon>
                      }
                      @if (!(item | checkedOrUnchecked: model.value)) {
                        <mat-icon
                          >cancel
                        </mat-icon>
                      }
                      {{ item.label[0].text }}
                    </div>
                  </div>
                }
                @case ('counter') {
                  <div
                    [zalamoTooltip]="item.description | langPicker | async"
                    >
                    {{ item.label | langPicker | async }}:
                    <span translate>clhosyo3h000208msg4bdenyp</span>
                    {{ item.counterConfig.min }}
                    <span translate>clhosyrhl000308ms0z94dv49</span>
                    {{ item.counterConfig.max }}
                  </div>
                }
                @case ('text') {
                  <div
                    [zalamoTooltip]="item.description | langPicker | async"
                    >
                    <span translate>clhosxv0q000008ms8ts2h0fc</span>: {{ item.label | langPicker | async }}
                  </div>
                }
              }
            </div>
          </ng-container>
        }
        @if (images.imagesRequired) {
          <h3>
            <span translate>clhosif6t000008lb16oi9aqy</span>:
            @if (images.requiredImages.min !== images.requiredImages.max) {
              <span  translate>clhosyo3h000208msg4bdenyp</span>
            }
            {{ images.requiredImages.min }}
            @if (images.requiredImages.min !== images.requiredImages.max) {
              <span translate>clhosj3zm000208lb8eqgbzn5</span>
              {{ images.requiredImages.max }}
            }
          </h3>
        }
        <h3>
          <span translate>clhosjif3000008l333v68xft</span>:
          {{ productInPackage.qty }}
        </h3>
      </div>
    </ng-template>
